import React from 'react';
import PropTypes from 'prop-types';
import {DropTarget} from 'react-dnd';
import DdTargetOverlay from './dd-target-overlay';
import classnames from 'classnames';
import {RGBFormatFromDecimal} from '../../../../utilities/common';
import {isEmpty} from '../../../../utilities/validation';

const boxTarget = {
    drop(props, monitor, component) { // eslint-disable-line no-unused-vars
        props.onDrop(monitor.getItem());
    },
};

const boxSource = { // eslint-disable-line no-unused-vars
    beginDrag(props) {
        return props;
    },
    endDrag(props, monitor, component) {
        const didDrop = monitor.didDrop();
        if (!didDrop) {
            component.props.onDropOut(monitor.getItem(), props);
            component.setState({movedOut: true});
        }
    }
};

const Types = {
    ITEM: 'item'
};

const getDataFromNode = function (node) {
    return ['id', 'title', 'capacity', 'swap', 'answer_type', 'snap_type', 'snap_animation_type',
        'snap_easing_type', 'snap_animation_length', 'x', 'y', 'width', 'height', 'enable_events', 'bgcolor',
        'bgalpha', 'answers', 'snap_offset',].reduce(
        (data, key) => {
            return {...data, [key]: node.attr[key]};
        }, {}
    );
};

export class DdTargetNode extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {id, x = 0, y = 0, width = 0, height = 0, snap_type = 'center', bgcolor, bgalpha = '',} = getDataFromNode(this.props.node);
        const {connectDropTarget, droppedItems = {}} = this.props;
        const nodeStyle = {
            left: `${x}px`,
            top: `${y}px`,
            width: `${width}px`,
            height: `${height}px`,
            backgroundColor: !isEmpty(bgcolor) ? RGBFormatFromDecimal(bgcolor, bgalpha) : 'transparent'
        };
        const {moduleURL = '' } = this.props;

        const targetStyle = {
            textAlign: 'center',
            padding: `${this.props.node.attr.snap_offset}px`
        };

        const nodeClasses = classnames({
            node: true,
            'flex-center-items': snap_type === 'center'
        });

        return connectDropTarget(
            <div className={nodeClasses} style={nodeStyle}>
                <div style={targetStyle}>
                    {droppedItems && droppedItems[id].map(node => {
                        return <DdTargetOverlay
                            moduleURL={moduleURL}
                            onDropOut={this.props.onDropOut}
                            id={`${node.node.attr.id}_dropped`}
                            key={`${node.node.attr.id}_dropped`}
                            node={node.node}
                            isDropped={true}
                        />;
                    })}
                </div>
            </div>
        );
    }
}

DdTargetNode.propTypes = {
    node: PropTypes.object.isRequired,
    onDrop: PropTypes.func.isRequired,
    droppedItems: PropTypes.object
};

export default DropTarget(Types.ITEM, boxTarget,
    (connect, monitor) => (
        {
            connectDropTarget: connect.dropTarget(),
            isOver: monitor.isOver(),
            didDrop: monitor.didDrop()
        }
    )
)(DdTargetNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/dd-target-node.js